import { Title } from "@gamesheet/ui";
import * as Grid from "@/layouts/GridItems";

export function JoinSeasonPage(){
    return (<>
        <Grid.Blank $column={1} $row={1}>
            <Title bartype="divider" text="Join Season" size="h2"/>
        </Grid.Blank>
    </>)
}